import * as pathToRegexpLib from 'path-to-regexp'

import {parseQueryString, toQueryString} from '@s-ui/js/lib/string'

import {SearchMappersFactory} from '../../search/Mappers/factory.js'
import {SearchValueObjectsFactory} from '../../search/ValueObjects/factory.js'
import PageValueObjectsFactory from '../ValueObjects/factory.js'
import {FromPageNameToConstantNamingPageName} from './FromPageNameToConstantNamingPageName.js'
import {FromPlaceholderUrlToNextPageUrl} from './FromPlaceholderUrlToNextPageUrl.js'
import {FromPlaceholderUrlToPreviousPageUrl} from './FromPlaceholderUrlToPreviousPageUrl.js'
import FromQueryParamsToPageNameValueObjectPageMapper from './FromQueryParamsToPageNameValueObjectPageMapper.js'
import FromQueryStringToQueryParamsMapper from './FromQueryStringToQueryParamsPageMapper.js'
import {FromStockUrlMapperToSearchValueObjectMapper} from './FromStockUrlMapperToSearchValueObjectMapper.js'
import UrlMapper from './UrlMapper.js'

// Detectar qué versión de path-to-regexp está disponible
const hasV8API = typeof pathToRegexpLib.match === 'function'

// Crear un wrapper para compatibilidad con path-to-regexp v1 y v8
const createPathMatcher = pattern => {
  // Si el pattern ya es un RegExp (como /\/.*-\d{4,9}-.*/), usarlo directamente
  if (pattern instanceof RegExp) {
    return {
      test: path => pattern.test(path)
    }
  }

  // Si el pattern contiene wildcards (*) de v1, convertir a RegExp
  // En v1: /concesionarios/* significa /concesionarios/cualquier-cosa
  if (typeof pattern === 'string' && pattern.includes('*')) {
    // Escapar caracteres especiales de RegExp excepto *
    const regexpStr = pattern
      .replace(/[.+?^${}()|[\]\\]/g, '\\$&') // Escapar caracteres especiales
      .replace(/\*/g, '.*') // Convertir * a .*
    const regexp = new RegExp(`^${regexpStr}$`)
    return {
      test: path => regexp.test(path)
    }
  }

  if (hasV8API) {
    // v8: usar match() function que retorna false o {path, params}
    try {
      const matcherFn = pathToRegexpLib.match(pattern, {decode: decodeURIComponent})
      return {
        test: path => matcherFn(path) !== false
      }
    } catch (error) {
      // Fallback: tratar el pattern como un string literal exacto si falla el parsing
      return {
        test: path => path === pattern
      }
    }
  } else {
    // v1: pathToRegexp retorna un RegExp directamente
    const pathToRegexpFn = pathToRegexpLib.default || pathToRegexpLib
    const regexp = pathToRegexpFn(pattern)
    return {
      test: path => regexp.test(path)
    }
  }
}

export default class PageMappersFactory {
  static fromPlaceholderUrlToNextPageUrl = () => new FromPlaceholderUrlToNextPageUrl()

  static fromPlaceholderUrlToPreviousPageUrl = () => new FromPlaceholderUrlToPreviousPageUrl()

  static fromPageNameToConstantNamingPageName = () => new FromPageNameToConstantNamingPageName()

  static fromQueryStringToQueryParamsPageMapper = () => new FromQueryStringToQueryParamsMapper({parseQueryString})

  static fromQueryParamsToTargetPageValueObjectPageMapper = ({config}) =>
    new FromQueryParamsToPageNameValueObjectPageMapper({
      valueObject: PageValueObjectsFactory.pageNamePageValueObject,
      config,
      pathToRegexp: createPathMatcher
    })

  static urlMapper = ({config}) =>
    new UrlMapper({
      config,
      toQueryString,
      fromPageNameToConstantNamingPageName: PageMappersFactory.fromPageNameToConstantNamingPageName(),
      valueObjectFactory: PageValueObjectsFactory.urlValueObject
    })

  static fromStockUrlMapperToSearchValueObjectMapper = ({config}) =>
    new FromStockUrlMapperToSearchValueObjectMapper({
      config,
      parseQueryString,
      fromSearchParamsToRequestVOMapper: SearchMappersFactory.fromSearchParamsToRequestVOMapper({config}),
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject
    })
}
